import { useEffect } from "react";
import { User, UserRound } from "lucide-react";
import PojkeIcon from "../../assets/images/Pojke.webp";
import FlickaIcon from "../../assets/images/Flicka.webp";

export const BasicInfoStep = ({ data, onUpdate, onNext }) => {
  useEffect(() => {
    console.log("BasicInfoStep data updated:", data);
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting form with data:", data);
    if (data.childName.trim() && data.childAge > 0 && data.gender) {
      onNext();
    } else {
      console.log("Form validation failed");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-8 animate-fadeIn p-4">
      <h2 className="text-2xl font-semibold text-center mb-8">
        Grundläggande information
      </h2>

      <div className="space-y-4">
        <label htmlFor="childName" className="block text-gray-700">
          Vad heter barnet?
        </label>
        <input
          id="childName"
          type="text"
          value={data.childName}
          onChange={(e) => onUpdate("childName", e.target.value)}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Skriv barnets namn"
          required
        />
      </div>

      <div className="space-y-4">
        <label htmlFor="childAge" className="block text-gray-700">
          Hur gammal är barnet?
        </label>
        <input
          id="childAge"
          type="number"
          min="0"
          max="99"
          value={data.childAge || ""}
          onChange={(e) => onUpdate("childAge", Number(e.target.value))}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>

      <div className="space-y-4">
        <label className="block text-gray-700">Barnets kön</label>
        <div className="grid grid-cols-2 gap-4">
          <div
            className={`p-4 border-2 rounded-lg cursor-pointer transition-transform transform hover:scale-105 text-center ${
              data.gender === "boy"
                ? "bg-white border-gray-200 scale-105 shadow-xl"
                : "bg-white border-gray-200"
            }`}
            onClick={() => onUpdate("gender", "boy")}
          >
            <img
              src={PojkeIcon}
              alt="Pojke"
              className="w-24 h-24 mx-auto rounded-full mb-2 object-cover"
            />
            <h3 className="text-lg font-medium">Pojke</h3>
          </div>

          <div
            className={`p-4 border-2 rounded-lg cursor-pointer transition-transform transform hover:scale-105 text-center ${
              data.gender === "girl"
                ? "bg-white border-gray-200 scale-105 shadow-xl"
                : "bg-white border-gray-200"
            }`}
            onClick={() => onUpdate("gender", "girl")}
          >
            <img
              src={FlickaIcon}
              alt="Flicka"
              className="w-24 h-24 mx-auto rounded-full mb-2 object-cover"
            />
            <h3 className="text-lg font-medium">Flicka</h3>
          </div>
        </div>
      </div>

      {/* NYTT FÄLT FÖR DEDIKERING */}
      <div className="space-y-4">
        <label htmlFor="dedication" className="block text-gray-700">
          Personlig dedikation (valfritt)
        </label>
        <textarea
          id="dedication"
          value={data.dedication || ""}
          onChange={(e) => onUpdate("dedication", e.target.value)}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 h-32"
          placeholder="Till exempel: Grattis på 6-årsdagen! Önskar farmor och farfar"
        />
        <p className="text-sm text-gray-500">
          Denna text kommer visas på baksidan av boken
        </p>
      </div>

      <button
        type="submit"
        className={`w-full text-white py-2 rounded-lg hover:opacity-90 transition ${
          data.childName.trim() && data.childAge > 0 && data.gender
            ? ""
            : "opacity-50 cursor-not-allowed"
        }`}
        style={
          data.childName.trim() && data.childAge > 0 && data.gender
            ? { background: "linear-gradient(90deg,rgb(51, 101, 126), #347fa4, rgb(51, 101, 126))" }
            : { backgroundColor: "#ccc" }
        }
        disabled={!data.childName.trim() || data.childAge <= 0 || !data.gender}
      >
        Nästa
      </button>
    </form>
  );
};